import "./journals-side-table.scss";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { journalsQueries } from "@/entities/journal";
import { useAmendmentsStore } from "@/features/journal-version-list";
import { useCoordinator, useNavigationPosition } from "@/shared/lib/hooks";
import { useFixPosition } from "./model";
import { SideButtonList, SideJournalsListNew } from "./ui";

interface IJournalsSideTable {
  control: any;
}

export const JournalsSideTable = ({ control }: IJournalsSideTable) => {
  const { titleId } = useCoordinator();
  const { data: titleData } = useQuery(
    journalsQueries.getTitleJournal({ titleId }),
  );
  const { isTitleAmendmentsForm } = useNavigationPosition();
  const { requestId } = useParams<{ requestId?: string }>();
  const currentAmendment = useAmendmentsStore((state) =>
    requestId
      ? (state.requests.find((request) => request.key === requestId) ?? null)
      : null,
  );
  const isSystemAmendment = currentAmendment?.requestSource === "SYSTEM";
  // @ts-expect-error versionNumber отсутствует в openapi типе TitleJournalViewDto
  const isShowDot = !titleData?.mainJournal?.titleJournal?.versionNumber;

  const { containerRef } = useFixPosition();

  return (
    <div
      className="table-container-side"
      id="journals-side-table"
      ref={containerRef}
    >
      {isSystemAmendment ? null : <SideJournalsListNew />}
      {!isSystemAmendment && (isShowDot || isTitleAmendmentsForm) ? (
        <SideButtonList control={control} />
      ) : null}
    </div>
  );
};
